/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import useRoleAPI from '../../hooks/network/useRoleAPI';
import NButton from '../../components/inputs/NButton';
import { RouteEnums } from '../../Routes/RoutesConstant';
import useSearchHook from '../../hooks/custom-hooks/useSearchHook';
import NSearch from '../../components/inputs/NSearch';
import NTable2 from '../../components/table/NTable2';
import MobileEdit from '../../assets/svg/MobileEdit';
import MobileDelete from '../../assets/svg/MobileDelete';
import { successToaster } from '../../components/toaster/Toaster';

function ManageRoles() {
  const navigate = useNavigate();
  const [roleList, setRoleList] = useState();
  const { searchValue, setSearchValue, searchHelper } = useSearchHook();
  const { isLoading, getRoles, deleteRole } = useRoleAPI();

  const columns = [
    {
      width: '35%',
      key: 'roleName',
      title: 'User Roles',
      isSortable: true,
      rowRender: (rowData) => <span> {rowData?.roleName} </span>,
    },
    {
      width: '35%',
      key: 'appAccess',
      title: 'Applications',
      rowRender: (rowData) => <span> {rowData?.appAccess?.map((s) => s)?.join(', ')} </span>,
    },
    {
      width: '30%',
      key: 'actions',
      title: 'Actions',
      columClassName: 'flex justify-end',
      rowRender: (rowData) => (
        <div>
          {/* Mobile */}
          <div className='flex items-center justify-end gap-6 break:hidden'>
            <div onClick={() => onClickEdit(rowData?.id)}>
              <MobileEdit />
            </div>
            <div onClick={() => onClickDelete(rowData?.id)}>
              <MobileDelete />
            </div>
          </div>

          {/* Desktop */}
          <div className='hidden gap-4 break:flex'>
            <NButton
              className='action-edit-btn'
              variant='outlined'
              startIcon={<EditIcon />}
              onClick={() => onClickEdit(rowData?.id)}
            >
              Edit
            </NButton>
            <NButton
              className='action-delete-btn'
              variant='outlined'
              startIcon={<DeleteIcon />}
              onClick={() => onClickDelete(rowData?.id)}
            >
              Delete
            </NButton>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      getRoles().then((data) => {
        setRoleList(data);
      });
    } catch {}
  };

  const onClickEdit = (id) => {
    navigate(`${RouteEnums.USER_ROLE_EDIT}/${id}`);
  };

  const onClickDelete = (id) => {
    const response = window.confirm('Press ok to delete role?');
    if (response) {
      successToaster(response?.message || 'Deleted Successfully');
      handleDeleteRole(id);
    }
  };

  const handleDeleteRole = async (roleId) => {
    try {
      const response = await deleteRole(roleId);
      if (!response) return;
      fetchRoles();
    } catch {}
  };

  const getRecords = () => {
    if (searchValue) {
      return searchHelper(roleList, ['roleName']);
    }
    return roleList || [];
  };

  return (
    <section className='n-table-wrapper'>
      {/* Mobile Header */}
      <div className='break:hidden'>
        <div className='mb-4 flex items-center justify-between'>
          <h2 className='font-semibold'>User Role</h2>
          <div>
            <div>
              <NButton variant='Noutline' onClick={() => navigate(RouteEnums.USER_ROLE_ADD)}>
                Add Role
              </NButton>
            </div>
          </div>
        </div>
        <div className='mb-4'>
          <NSearch value={searchValue} onChange={(e) => setSearchValue(e?.target?.value)} />
        </div>
      </div>

      {/* Desktop Header */}
      <div className='mb-10 mt-4 hidden w-full flex-wrap items-start justify-between gap-4 break:flex'>
        <div>
          <NSearch value={searchValue} onChange={(e) => setSearchValue(e?.target?.value)} />
        </div>
        <div>
          <NButton
            className='!bg-nblue text-nblue'
            onClick={() => navigate(RouteEnums.USER_ROLE_ADD)}
          >
            Add Role
          </NButton>
        </div>
      </div>
      <div className={`${!isLoading ? 'ntable-container' : ''}`}>
        <NTable2 isLoading={isLoading} rows={getRecords()} columns={columns} />
      </div>
    </section>
  );
}

ManageRoles.propTypes = {};

export default ManageRoles;
